<template>
  <div class="datacenter-section">
    <div class="mx-4 mb-3">
      <v-row class="mb-4">
        <v-col lg="6" md="12" cols="12">
          <v-card class="d-flex flex-column" height="100%">
            <v-card-title class="xlg--text fontweight400 pt-6">
              Current subscription</v-card-title
            >
            <v-card-text
                class="text--primary"
                v-if="!!datacenter_subscription && !!datacenter_subscription.plan_name"
            >
              <p class="fontlight--text xs--text">
                Current plan:
                <router-link
                    class="text-decoration router-link"
                    to="/subscriptions?tab=datacenter"
                ><b>{{ datacenter_subscription.plan_name }}</b></router-link
                >
              </p>
              <p class="fontlight--text xs--text">
                Start date:
                <b>{{ parseDate(datacenter_subscription.start_date) }}</b>
              </p>
              <p class="fontlight--text xs--text">
                {{ datacenter_subscription.recurring ? 'Renewal date:' : 'End date:'}}
                <b>{{ parseDate(datacenter_subscription.end_date) }}</b>
              </p>
              <p class="fontlight--text xs--text">
                Username:
                <b>{{ datacenter_credentials.proxy_username }}</b>
              </p>
              <p class="fontlight--text xs--text">
                Password:
                <b>{{ datacenter_credentials.proxy_secret }}</b>
              </p>
              <v-progress-linear
                  color="primary"
                  height="20"
                  :value="datacenterUsageValue"
                  striped
              >
                <template v-slot:default="{ value }">
                  <strong>{{ Math.round(value * 100) / 100 }}%</strong>
                </template>
              </v-progress-linear>
              <p class="fontlight--text xs--text">
                You have consumed
                <b>{{ datacenter_subscription.traffic_used_gb.toLocaleString() }}</b>
                from <b>{{ datacenter_subscription.traffic_limit_gb.toLocaleString() }}</b> available GBs
              </p>
              <p
                  class="fontlight--text xs--text"
                  v-if="datacenter_subscription.traffic_used_gb >= datacenter_subscription.traffic_limit_gb"
              >
                You've run out of traffic in the current subscription.
                Please, visit
                <router-link
                    class="text-decoration router-link"
                    to="/subscriptions?tab=datacenter"
                >Subscriptions</router-link
                >
                to Upgrade your plan or
                <a
                    class="text-decoration router-link"
                    href="mailto:support@scrapingant.com"
                >Contact Us</a
                >
                to discuss a custom plan.
              </p>
            </v-card-text>
            <v-card-text v-else>
              <p class="fontlight--text xs--text">
                No active subscription. Please
                <router-link
                    :to="{ path: '/subscriptions?tab=datacenter' }" class="text-decoration router-link"
                >subscribe</router-link>
                to datacenter proxies subscription.
              </p>
            </v-card-text>
            <v-spacer></v-spacer>
          </v-card>
        </v-col>
        <v-col lg="6" md="12" cols="12">
          <v-row class="ma-0">
            <v-col class="pa-0 mb-6" cols="12">
              <v-card>
                <v-card-title class="">
                  <v-icon class="mr-2" :color="doc_icon">{{ doc_icon }}</v-icon>
                  {{ doc_title }}</v-card-title>
                <v-card-text>
                  <p class="fontlight--text xs--text">
                    {{ doc_content }}
                  </p>
                </v-card-text>
                <v-card-actions class="justify-end">
                  <v-btn text class="fontweight400" target="_blank"
                         href="https://proxydocs.scrapingant.com">
                    Follow the docs
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-col>
            <v-col
                class="pa-0 mb-6"
                cols="12"
                v-if="datacenter_subscription && datacenter_subscription.update_url && datacenter_subscription.recurring"
            >
              <v-card>
                <v-card-title class="xlg--text fontweight400 pt-6">
                  Payment details
                </v-card-title>
                <v-card-text>
                  <p class="fontlight--text xs--text">
                    Change and update payment details
                  </p>
                </v-card-text>
                <v-card-actions class="justify-end">
                  <v-btn
                      text
                      class="fontweight400"
                      @click="onUpdatePaymentDetailsClicked"
                  >
                    Update payment
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </div>

    <div v-if="datacenter_credentials && datacenter_credentials.proxy_username" class="mx-4 mb-10 custom-requesgenerator">
      <v-card>
        <v-card-title class="xlg--text fontweight400 pt-6"
        >Request generator</v-card-title
        >
        <v-card-text>
          <div>
            <v-row>
              <v-col lg="6" md="12" cols="12">
                <v-row>
                  <v-col lg="12" md="12" cols="12">
                    <v-text-field
                        hide-details
                        label="URL"
                        v-model="url"
                        required
                    ></v-text-field>
                  </v-col>
                  <v-col lg="6" md="12" cols="12">
                    <v-text-field hide-details
                                  label="Proxy country"
                                  v-model="request_generator.country"
                                  class="mt-3"
                    ></v-text-field>
                  </v-col>
                  <v-col lg="6" md="12" cols="12">
                      <v-text-field hide-details
                                    label="Session ID"
                                    v-model="request_generator.sessionid"
                                    class="mt-3"
                      ></v-text-field>
                  </v-col>
                </v-row>
              </v-col>

              <v-col lg="6" md="12" cols="12">
                <h3 class="pt-6 fontlight--text">CURL</h3>
                <v-row>
                  <v-col class="text-end">
                    <prism
                        :language="templates[0].prism_language"
                        :code="templates[0].get_template"
                    ></prism>
                    <v-btn
                        text
                        v-clipboard:success="onCopiedToClipboard"
                        v-clipboard="() => templates[0].get_template"
                    >Copy to clipboard
                    </v-btn>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </div>
        </v-card-text>
      </v-card>
    </div>

    <div class="mx-4 mb-4">
      <v-card>
        <v-card-title> <div class="md-title">Usage chart</div></v-card-title>
        <v-card-text>
          <v-progress-circular
              v-if="usage_grapph_loading"
              :size="50"
              :width="2"
              color="primary"
              indeterminate
          ></v-progress-circular>
          <usage-chart v-if="!usage_grapph_loading"
                       :start-date="parseDate(datacenter_subscription.start_date)"
                       :chart-data="datacenter_chartdata"
          /> </v-card-text
        >
      </v-card>
    </div>

    <div class="loading-overlay" v-if="loading">
      <v-progress-circular
          :size="50"
          :width="2"
          color="primary"
          indeterminate
      ></v-progress-circular>
    </div>
  </div>
</template>

<script>
import UsageChart from "../views/UsageChart";
import "prismjs/themes/prism.css";
import Prism from "vue-prismjs";
import {datacenterProxyTemplates} from "@/helper/proxy-template-helper";
import getDateUTCString from "@/utils/date_utils";
import constants from "@/config/constants";

export default {
  name: "ResidentialProxies",
  components: {Prism, UsageChart },
  data() {
    return {
      request_generator: {
        country: "",
        sessionid: ""
      },
      url: "https://example.com",
      datacenter_subscription: {},
      datacenter_credentials: {},
      datacenter_chartdata: {
        labels: [],
        datasets: [
          {
            label: "Datacenter proxy usage",
            lineTension: 0.2,
            borderWidth: 2,
            pointRadius: 2,
            backgroundColor: "#FFFFFF00",
            borderColor: "#E2782F",
            pointBorderColor: "#E2782F",
            pointBackgroundColor: "#E2782F",
            data: [],
          },
        ],
      },
      loading: false,
      result_loading: false,
      usage_graph_loading: false,
      doc_title: "API Documentation",
      doc_icon: 'mdi-help-circle-outline',
      doc_content: 'Make sure not to miss our new features by reading docs!',
    };
  },
  computed: {
    datacenterUsageValue() {
      return this.datacenter_subscription
          ? this.datacenter_subscription.traffic_used_gb / this.datacenter_subscription.traffic_limit_gb * 100
          : 0;
    },
    templates() {
      return [
        {
          name: 'curl',
          get_template: datacenterProxyTemplates.CURL.get(this.request_generator, this.datacenter_credentials['proxy_username'], this.datacenter_credentials['proxy_secret'], this.url),
          prism_language: "bash",
        }
      ]
    }
  },
  methods: {
    getDatacenterUsageGraph() {
      this.usage_graph_loading = true;
      return this.$store.dispatch("dashboard/getDatacenterUsageGraph").then((res) => {
        this.usage_graph_loading = false;
        const newChartData = Object.assign({}, this.datacenter_chartdata);
        newChartData.labels = res.data.labels;
        newChartData.datasets[0] = {
          label: 'MBs used',
          lineTension: 0.2,
          borderWidth: 2,
          pointRadius: 2,
          backgroundColor: '#FFFFFF00',
          borderColor: '#E2782F',
          pointBorderColor: '#E2782F',
          pointBackgroundColor: '#E2782F',
          data: res.data.data
        };
        if (res.data.detailed_view) {
          res.data.detailed_view.forEach((userData, i) => {
            newChartData.datasets.push({
              label: userData.email,
              lineTension: 0.2,
              borderWidth: 2,
              pointRadius: 2,
              backgroundColor: '#E2782F99',
              borderColor: '#E2782F99',
              pointBorderColor: '#E2782F99',
              pointBackgroundColor: '#E2782F99',
              borderDash: [(i + 1) * 2, i + 1],
              data: userData.data
            });
          });
        }
        this.datacenter_chartdata = newChartData;
      }, () => {
        this.usage_graph_loading = false;
      });
    },

    getCurrentDatacenterSubscription() {
      return this.$store
          .dispatch("dashboard/getCurrentDatacenterSubscription")
          .then((res) => {
            this.datacenter_subscription = res;
          }, console.error);
    },

    getDatacenterCredentials() {
      return this.$store
          .dispatch("dashboard/getDatacenterCredentials")
          .then((res) => {
            this.datacenter_credentials = res;
          }, console.error);
    },

    parseDate(date) {
      return getDateUTCString(new Date(date));
    },

    getUTCDateString(timestamp) {
      return getDateUTCString(new Date(timestamp * 1000));
    },

    reload() {
      this.$router.go();
    },
    onUpdatePaymentDetailsClicked() {
      // eslint-disable-next-line no-undef
      Paddle.Checkout.open({
        override: this.datacenter_subscription.update_url,
        successCallback: () => {
          // TODO: add logging for tracking
        },
        closeCallback: () => {
          // TODO: add logging for tracking
        },
      });
    },
    onCopiedToClipboard({ value }) {
      console.log("success", value);
      this.$notify({
        group: "main",
        text: "Copied to clipboard!",
        duration: 500,
      });
    },
  },
  mounted() {
    this.loading = true;
    Promise.all([
      this.getCurrentDatacenterSubscription(),
      this.getDatacenterCredentials(),
    ]).then(
        () => (this.loading = false),
        () => (this.loading = false)
    );
    this.getDatacenterUsageGraph();
    const randomDoc = constants.RANDOM_STRINGS_TO_ENDORSE_DOCUMENTATION_READING_DATACENTER[
        Math.floor(Math.random() * constants.RANDOM_STRINGS_TO_ENDORSE_DOCUMENTATION_READING_DATACENTER.length)
        ];

    this.doc_content = randomDoc.content;
    this.doc_title = randomDoc.title;
    this.doc_icon = randomDoc.icon;
  },
};
</script>

<style scoped>
.md-card {
  margin: 15px;
}

.md-dialog-container {
  width: 50%;
  height: 75%;
}

pre[class*="language-"] {
  max-height: 30em;
  border-radius: 2px;
  background-color: #f7f7f7;
  box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14),
  0 1px 5px 0 rgba(0, 0, 0, 0.12);
}

.execution-notice {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100px;
  width: 100%;
  height: 75%;
}

.execution-spinner {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 100px;
}
</style>
